'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Triangles;

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _Point = require('./Point');

var _Point2 = _interopRequireDefault(_Point);

var _Rectangle = require('./Rectangle');

var _Rectangle2 = _interopRequireDefault(_Rectangle);

var _Triangle = require('./Triangle');

var _Triangle2 = _interopRequireDefault(_Triangle);

var _Gradient = require('./Gradient');

var _Gradient2 = _interopRequireDefault(_Gradient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Triangles(_ref) {
  var id = _ref.id,
      cb = _ref.cb,
      _ref$dark = _ref.dark,
      dark = _ref$dark === undefined ? 20 : _ref$dark,
      _ref$light = _ref.light,
      light = _ref$light === undefined ? 45 : _ref$light,
      _ref$darkColor = _ref.darkColor,
      darkColor = _ref$darkColor === undefined ? 'rgba(255, 122, 5, 0.3)' : _ref$darkColor,
      _ref$lightColor = _ref.lightColor,
      lightColor = _ref$lightColor === undefined ? 'rgba(246, 90, 90, 0.3)' : _ref$lightColor,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 25 : _ref$size,
      _ref$refreshTime = _ref.refreshTime,
      refreshTime = _ref$refreshTime === undefined ? 50 : _ref$refreshTime;

  var canvas = document.getElementById(id);
  var container = canvas.parentNode;

  var calledCallback = false;
  var triangles = void 0,
      ctx = void 0,
      width = void 0,
      height = void 0,
      i = void 0,
      j = void 0,
      gradient = void 0,
      paintInterval = void 0;

  var paint = function paint() {
    triangles = {};

    if (paintInterval) {
      clearInterval(paintInterval);
    }

    gradient = new _Gradient2.default({ initial: dark, end: light, width: width, height: height, jumps: size });

    ctx = canvas.getContext('2d');
    new _Rectangle2.default({ width: width, height: height, color: 'rgb(' + [light, light, light].join(',') + ')' }).draw(ctx);

    for (i = 0; i < width / size + size; i++) {
      triangles[i] = {};
      for (j = 0; j < height / size + size; j++) {
        triangles[i][j] = new _Triangle2.default({
          initialPoint: new _Point2.default(i * size, j * size),
          width: size,
          gradient: gradient,
          darkColor: darkColor,
          lightColor: lightColor
        }).init(ctx);
      }
    }

    paintInterval = setInterval(function () {
      for (i = 0; i < width * 0.2 / size; i++) {
        for (j = 0; j < height * 0.2 / size; j++) {
          triangles[Math.floor(Math.random() * width / size)][Math.floor(Math.random() * height / size)].redraw(ctx);
        }
      }
    }, refreshTime);
  };

  var resize = (0, _lodash2.default)(function () {
    canvas.setAttribute('width', width = container.clientWidth);
    canvas.setAttribute('height', height = container.clientHeight);
    paint();

    if (!calledCallback && typeof cb === 'function') {
      calledCallback = true;
      cb();
    }
  }, 100);

  resize();

  canvas.addEventListener('mousemove', function (evt) {
    var rect = canvas.getBoundingClientRect();
    var interval = void 0;
    var toRedraw = [];

    var mousePos = new _Point2.default(Math.floor((evt.clientX - rect.left) / size), Math.floor((evt.clientY - rect.top) / size));
    toRedraw.push(triangles[mousePos.x][mousePos.y].colorRedraw());

    if (triangles[mousePos.x + 1] && triangles[mousePos.x + 1][mousePos.y + 1]) {
      toRedraw.push(triangles[mousePos.x + 1][mousePos.y + 1].colorRedraw());
    }

    if (triangles[mousePos.x - 1] && triangles[mousePos.x - 1][mousePos.y + 1]) {
      toRedraw.push(triangles[mousePos.x - 1][mousePos.y + 1].colorRedraw());
    }

    if (triangles[mousePos.x + 1] && triangles[mousePos.x + 1][mousePos.y - 1]) {
      toRedraw.push(triangles[mousePos.x + 1][mousePos.y - 1].colorRedraw());
    }

    if (triangles[mousePos.x - 1] && triangles[mousePos.x - 1][mousePos.y - 1]) {
      toRedraw.push(triangles[mousePos.x - 1][mousePos.y - 1].colorRedraw());
    }

    if (triangles[mousePos.x][mousePos.y + 1]) {
      toRedraw.push(triangles[mousePos.x][mousePos.y + 1].colorRedraw());
    }

    if (triangles[mousePos.x][mousePos.y - 1]) {
      toRedraw.push(triangles[mousePos.x][mousePos.y - 1].colorRedraw());
    }

    if (triangles[mousePos.x][mousePos.y - 1]) {
      toRedraw.push(triangles[mousePos.x][mousePos.y - 1].colorRedraw());
    }

    if (triangles[mousePos.x][mousePos.y + 1]) {
      toRedraw.push(triangles[mousePos.x][mousePos.y + 1].colorRedraw());
    }

    interval = function () {
      return setInterval(function () {
        toRedraw[Math.floor(Math.random() * toRedraw.length)].redraw(ctx);
      }, 200);
    }();

    setTimeout(function () {
      clearInterval(interval);
      while (toRedraw.length > 0) {
        toRedraw.pop().grayRedraw(ctx);
      }
    }, 1000);
  }, false);

  if (window.attachEvent) {
    window.attachEvent('onresize', resize);
  } else if (window.addEventListener) {
    window.addEventListener('resize', resize, true);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/triangles-canvas/dist/index.js
// module id = 438
// module chunks = 35783957827783